<template>
    <div
        :style="{ display: open ? '' : 'none' }"
        :class="classes.concat([$style.modalDialogComponent])"
    >
        <button
            :class="[$style.closeButton]"
            v-if="closeButton === true"
            @click="closeDialog()"
        >
            ×
        </button>
        <slot></slot>
    </div>
</template>

<style module>
body > .modalDialogOverlay {
    background-color: rgba(0, 0, 0, 0.25);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2000;
    overflow: hidden;
}

.modalDialogComponent {
    z-index: 2001;
    position: relative;
    overflow: visible;
}

.modalDialogComponent .closeButton {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 28px;
    height: 28px;
    margin-right: -10px;
    margin-top: -10px;
    border: 2px solid white;
    background-color: black;
    border-radius: 100%;
    color: white;
    cursor: pointer;
    font-size: 24px;
    line-height: 0px;
    font-weight: 700;
    padding: 0;
    z-index: 1;
}
</style>

<script lang="ts">

export default ({
    name: "modal-dialog",
    props: {
        autoOpen: Boolean,
        closeButton: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: Array,
            default() {
                return [];
            },
        },
        opacity: {
            type: [Number, String],
            default: -1,
        },
    },
    data() {
        return {
            overlayElement: null as null | HTMLElement,
            open: false,
        };
    },
    methods: {
        initOverlay() {
            if (this.overlayElement === null) {
                const modalDialogOverlay = (this as any).$style
                    .modalDialogOverlay;
                this.overlayElement = document.createElement("div");
                this.overlayElement.classList.add(modalDialogOverlay);
                this.overlayElement.style.backgroundColor =
                    this.getOverlayBackgroundColor();
                this.overlayElement.addEventListener("click", () => {
                    this.closeDialog();
                });
            }
        },
        getOverlayBackgroundColor() {
            if (this.opacity === -1) return "";
            return (
                "rgba(0,0,0," +
                (typeof this.opacity === "string"
                    ? parseFloat(this.opacity)
                    : this.opacity) +
                ")"
            );
        },
        showOverlay() {
            this.initOverlay();
            const overlay = this.overlayElement;
            overlay?.ownerDocument.body.prepend(overlay);
        },
        hideOverlay() {
            this.initOverlay();
            this.overlayElement?.remove();
        },
        openDialog() {
            this.showOverlay();
            this.open = true;
            this.$emit("open-dialog");
        },
        closeDialog() {
            this.hideOverlay();
            this.open = false;
            this.$emit("close-dialog");
        },
    },
    mounted() {
        if (this.autoOpen === true) {
            this.openDialog();
        }
    },
});
</script>
